import { styled } from 'styled-components';

import { ListHorizontal } from '../ListHorizontal';

const StyledListHorizontal = styled(ListHorizontal)`
	padding: 10px;
	border-radius: 10px;
	background-color: rgba(0, 0, 0, 0.5);
`;

export { StyledListHorizontal };
